import { DumpsterSize, DumpWeightByMaterial } from "../../../models";
import { RawDumpWeightByMaterial } from "../normalizers/getDumpWeightByMaterial";

export function dumpWeightByMaterial(
  w: DumpWeightByMaterial
): RawDumpWeightByMaterial {
  const out: RawDumpWeightByMaterial = {};
  for (const size of Object.keys(w)) {
    const byMaterial = w[size as DumpsterSize];
    const strs: Record<string, string> = {};
    for (const material of Object.keys(byMaterial)) {
      strs[material] = String(byMaterial[material]);
    }
    out[size] = strs;
  }
  return out;
}
